import { coreInstance } from './http';
import { extractApiError } from '../lib/extractApiError';

export const getPseudoOrder = (id, convertToCargo) => {
  const query = convertToCargo ? `?uuid=${id}&convert_to_cargo=true` : `?uuid=${id}`;
  return coreInstance
    .get(`/api/v1/buyback/order/get${query}`)
    .then((res) => {
      if (res.data.success) {
        return {
          success: true,
          data: res.data.data,
        };
      } else {
        return {
          success: false,
          data: res.data.data,
        };
      }
    })
    .catch((err) => {
      console.log(err);
      return {
        success: false,
        status: err.response?.status,
        data: err.response?.data,
      };
    });
};

export const createPayment = (data, convertToCargo) => {
  const url = convertToCargo
    ? `/api/v1/buyback/order/courier/convert-to-cargo/create-payment`
    : `/api/v1/buyback/order/create-payment`;
  return coreInstance
    .post(url, data)
    .then((res) => {
      if (res.data.success) {
        return {
          success: true,
          data: res.data.data,
        };
      } else {
        return {
          success: false,
          data: res.data.data,
          error: extractApiError(res.data),
        };
      }
    })
    .catch((err) => {
      console.log(err);
      return {
        success: false,
        status: err.response?.status,
        data: err.response?.data,
        error: extractApiError(err.response?.data),
      };
    });
};

// ------------------- //

export const getLead = (id) => {
  return coreInstance
    .get(`/api/v1/hepsijet/get_lead?offer_id=${id}`)
    .then((res) => {
      if (res.data.success) {
        return {
          success: true,
          data: res.data.data,
        };
      } else {
        return {
          success: false,
          data: res.data.data,
        };
      }
    })
    .catch((err) => {
      console.log(err);
      return {
        success: false,
        status: err.response?.status,
        data: err.response?.data,
      };
    });
};

export const getQuestions = () => {
  return coreInstance
    .get(`/api/v1/buyback/pricing/get_questions`)
    .then((res) => {
      if (res.data.success) {
        return {
          success: true,
          data: res.data.data,
        };
      } else {
        return {
          success: false,
          data: res.data.data,
        };
      }
    })
    .catch((err) => {
      console.log(err);
      return {
        success: false,
        status: err.response?.status,
        data: err.response?.data,
      };
    });
};

export const getDeviceOffer = (data) => {
  return coreInstance
    .post(`/api/v1/buyback/pricing/get_device_offer`, data)
    .then((res) => {
      if (res.data.success) {
        return {
          success: true,
          data: res.data.data,
        };
      } else {
        return {
          success: false,
          data: res.data.data,
        };
      }
    })
    .catch((err) => {
      console.log(err);
      return {
        success: false,
        status: err.response?.status,
        data: err.response?.data,
      };
    });
};

export const createOrder = (data) => {
  return coreInstance
    .post(`/api/v1/buyback/order/create`, data)
    .then((res) => {
      if (res.data.success) {
        return {
          success: true,
          data: res.data.data,
        };
      } else {
        return {
          success: false,
          data: res.data.data,
        };
      }
    })
    .catch((err) => {
      console.log(err);
      return {
        success: false,
        status: err.response?.status,
        data: err.response?.data,
      };
    });
};

export const getCancelReasons = () => {
  return coreInstance
    .get(`/api/v1/buyback/get_tradein_cancel_reasons`)
    .then((res) => {
      if (res.data.success) {
        return {
          success: true,
          data: res.data.data,
        };
      } else {
        return {
          success: false,
          data: res.data.data,
        };
      }
    })
    .catch((err) => {
      console.log(err);
      return {
        success: false,
        status: err.response?.status,
        data: err.response?.data,
      };
    });
};
